import styled from "@emotion/styled";
import Tooltip from "uis/Tooltip";
import UI from "@mile-meeting/mile-ui";

type DashboardTileProps = {
  flexibleTitle?: string;
  title: string;
  mainValue: string;
  subValue?: string;
  explain?: string;
  isDisabled?: boolean;
};

const TileContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;

  padding: 20px;
  border-radius: 12px;
  background-color: var(--component-color-fill-alternative);

  white-space: nowrap;
  overflow: hidden;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;
const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export default function DashboardTile(props: DashboardTileProps) {
  const { flexibleTitle, title, explain="", mainValue, subValue, isDisabled=false } = props;
  
  return (
    <TileContainer>
      <TitleContainer>
        { flexibleTitle && 
          <UI.Typography 
            type="body01 normal" 
            fontStyle="medium" 
            color={isDisabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
            style={{textAlign: "end", overflow: "hidden", textOverflow: "ellipsis"}}
          >
            {flexibleTitle}
          </UI.Typography>
        }
        <UI.Typography 
          type="body01 normal" 
          fontStyle="medium" 
          color={isDisabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}>
          {title}
        </UI.Typography>
        <Tooltip isDisabled={isDisabled} explain={explain}/>
      </TitleContainer>
      <ValueContainer>
        { subValue && 
          <UI.Typography 
            type="body01 normal" 
            fontStyle="medium" 
            color={isDisabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
            style={{textAlign: "end", overflow: "hidden", textOverflow: "ellipsis"}}
          >
            {subValue}
          </UI.Typography>
        }
        <UI.Typography 
          type="heading02" 
          fontStyle="bold" 
          color={isDisabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-strong)"}
          style={{textAlign: "end", overflow: "hidden", textOverflow: "ellipsis"}}
        >
          {mainValue}
        </UI.Typography>
      </ValueContainer>
    </TileContainer>
  );
}
